import { render, staticRenderFns } from "./ecpf.vue?vue&type=template&id=695b97bf&scoped=true"
import script from "./ecpf.vue?vue&type=script&lang=js"
export * from "./ecpf.vue?vue&type=script&lang=js"
import style0 from "./ecpf.vue?vue&type=style&index=0&id=695b97bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695b97bf",
  null
  
)

export default component.exports